// extracted by mini-css-extract-plugin
export var dividerLine = "_8w-3";
export var itemImage = "_8w-9";
export var lightDivider = "_8w-4";
export var modalContent = "_8w-5";
export var modalContentCompact = "_8w-6";
export var productCard = "_8w-a";
export var productImage = "_8w-b";
export var productImageCompact = "_8w-7";
export var productImagePlaceholder = "_8w-c";
export var productImagePlaceholderCompact = "_8w-8";
export var progressBarBackground = "_8w-1";
export var progressBarContainer = "_8w-0";
export var progressBarFill = "_8w-2";